import './Paymentloader.css'









const Paymentloader = () => {
    return (
        <>
            <div className="boom-loader">

                <div className="transaction-scene">


                    <div className="speed-lines">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>


                    <div className="coin coin-1">₹</div>
                    <div className="coin coin-2">₹</div>
                    <div className="coin coin-3">₹</div>
                    <div className="coin coin-4">₹</div>


                    <div className="processing-core">
                        <div className="core-ring"></div>

                        <div className="core-icon">
                            ₹
                        </div>
                    </div>


                    <div className="coin outgoing out-1">₹</div>
                    <div className="coin outgoing out-2">₹</div>
                    <div className="coin outgoing out-3">₹</div>

                </div>

                <div className="transaction-text">
                    <strong>Processing payment</strong>
                    <span>Please wait while we process your transaction</span>
                </div>

            </div>
        </>
    )

}

export default Paymentloader;